export type FontVariant = {
  fontName?: string;
  fontData: string;
  system?: boolean;
  opts:
    | {
        offsetX: number;
        offsetY: number;
      }
    | {
        pageSize: number;
        padding: number;
      };
};

export type VariantSet = {
  variants: Partial<Record<string, FontVariant>>;
  aliases: Partial<Record<string, string>>;
};

const variantSet1: VariantSet = {
  variants: {
    Title: {
      fontName: 'riffic',
      fontData: 'riffic_stroke',
      opts: { offsetX: 5, offsetY: 4 },
    },
    Body: {
      fontName: 'riffic',
      fontData: 'riffic',
      opts: { offsetX: 5, offsetY: 4 },
    },
    TitleBig: {
      fontName: 'riffic',
      fontData: 'riffic_stroke_big',
      opts: { offsetX: 7, offsetY: 6 },
    },
    BodyBig: {
      fontName: 'riffic',
      fontData: 'riffic_big',
      opts: { offsetX: 7, offsetY: 6 },
    },
    NumbersStroke: {
      fontName: 'paytone_number',
      fontData: 'paytone_number_stroke',
      opts: { offsetX: 0, offsetY: 70 },
    },
    Numbers: {
      fontName: 'paytone_number',
      fontData: 'paytone_number',
      opts: { offsetX: 0, offsetY: 42 },
    },
    Legal: {
      system: true,
      fontData: 'arial_stroke',
      opts: { pageSize: 128, padding: 0.25 },
    },
  },
  aliases: {
    PlayerNames: 'Body',
    PlayerNamesStroke: 'Title',
  },
};

const variantSet2: VariantSet = {
  variants: {
    Title: {
      fontName: 'mplus',
      fontData: 'mplus_stroke',
      opts: { offsetX: 5, offsetY: 4 },
    },
    Body: {
      fontName: 'mplus',
      fontData: 'mplus',
      opts: { offsetX: 5, offsetY: 4 },
    },
    TitleBig: {
      fontName: 'mplus',
      fontData: 'mplus_stroke_big',
      opts: { offsetX: 7, offsetY: 6 },
    },
    BodyBig: {
      fontName: 'mplus',
      fontData: 'mplus_big',
      opts: { offsetX: 7, offsetY: 6 },
    },
    NumbersStroke: {
      fontName: 'paytone_number',
      fontData: 'paytone_number_stroke',
      opts: { offsetX: 0, offsetY: 70 },
    },
    Numbers: {
      fontName: 'paytone_number',
      fontData: 'paytone_number',
      opts: { offsetX: 0, offsetY: 42 },
    },
    PlayerNames: {
      system: true,
      fontData: 'arial',
      opts: { pageSize: 2048, padding: 0.3 },
    },
    PlayerNamesStroke: {
      system: true,
      fontData: 'arial_stroke',
      opts: { pageSize: 2048, padding: 0.3 },
    },
  },
  aliases: {
    Legal: 'PlayerNamesStroke',
  },
};

export type FontsSkin = {
  en: VariantSet;
  ja: VariantSet;
};

const fontsSkin: FontsSkin = {
  en: variantSet1,
  ja: variantSet2,
};

export default fontsSkin;
